var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "shop-edit contents" },
    [
      _vm.form.hasErrors()
        ? _c("div", { staticClass: "ui warning message" }, [
            _vm._v("入力エラー"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ui pointing secondary menu" }, [
        _c("a", { staticClass: "item", attrs: { "data-tab": "basic" } }, [
          _vm._v("基本情報"),
        ]),
        _vm._v(" "),
        _c("a", { staticClass: "item", attrs: { "data-tab": "photo" } }, [
          _vm._v("写真"),
        ]),
        _vm._v(" "),
        _c("a", { staticClass: "item", attrs: { "data-tab": "menu" } }, [
          _vm._v("メニュー"),
        ]),
        _vm._v(" "),
        _c("a", { staticClass: "item", attrs: { "data-tab": "room" } }, [
          _vm._v("会場"),
        ]),
        _vm._v(" "),
        _c("a", { staticClass: "item", attrs: { "data-tab": "facility" } }, [
          _vm._v("設備"),
        ]),
        _vm._v(" "),
        _vm.isAdministrator
          ? _c("a", { staticClass: "item", attrs: { "data-tab": "account" } }, [
              _vm._v("ログイン情報"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("basic-tab", {
        attrs: { form: _vm.form },
        on: {
          save: function ($event) {
            return _vm.save()
          },
        },
      }),
      _vm._v(" "),
      _c("photo-tab", { ref: "photoTab" }),
      _vm._v(" "),
      _c("menu-tab", { ref: "menuTab" }),
      _vm._v(" "),
      _c("room-tab", { ref: "roomTab" }),
      _vm._v(" "),
      _c("facility-tab", { ref: "facilityTab" }),
      _vm._v(" "),
      _vm.isAdministrator ? _c("account-tab", { ref: "accountTab" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }